import * as t from "io-ts";
import {MessageArrayValidator} from "./message";

/** Site work a driver performs between tickets, as it appears in driver activity. */
export const ServiceWorkValidator = t.intersection([
  t.type({
    id: t.string,
    startDttm: t.number,
  }),
  t.partial({
    endDttm: t.number,
    personId: t.string,
    personName: t.string,
    siteId: t.string,
    siteName: t.string,
    siteCompanyId: t.string,
    siteCompanyName: t.string,
    serviceTypeId: t.string,
    serviceTypeName: t.string,
    resourceId: t.string,
    billableHours: t.number,
    billableQty: t.number,
    totalCost: t.number,
    messages: MessageArrayValidator,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
]);

export type ServiceWork = t.TypeOf<typeof ServiceWorkValidator>;
